module.exports = __webpack_public_path__ + "img/130.665f8fb5.jpg";